import React, {useEffect, useState} from 'react';
import {ArrowLeftOutlined} from "@ant-design/icons";
import {NavBar} from "antd-mobile";
import {getNavBarContainerStyle} from "../../../../utils/deviceUtils";
import {useNavigate} from "react-router-dom";
import {TaskPath} from "../../../../enums/DeliveryNavigatePathEnum";
import {TrackingTableTitle} from 'enums/DeliveryTrackingTableEnum';
import {t} from "../../../../i18n";

export interface OrderBaseItem {
    trackingNumber: string;
    value: string;
    stop?: string;
}

interface TrackingTableProps {
    title: string;
    tableRows: String[];
    data: OrderBaseItem[];
}

const TrackingTable: React.FC<TrackingTableProps> = ({title, tableRows, data}) => {
    const navigate = useNavigate();
    const [path, setPath] = useState<string>(TaskPath.DELIVERY_TASK);
    const [head, setHead] = useState<string>(title);

    useEffect(() => {
        if (title === TrackingTableTitle.TRANSFER_IN_DETAILS){
            setPath(TaskPath.DELIVERY_TASK_TRANSFER_IN);
            setHead(t('pages.details'));
        }
        if (title === TrackingTableTitle.TRANSFER_OUT){
            setHead(t('pages.delivery.task.transferOutTitle'));
        }
        if (title === TrackingTableTitle.RETURN_TO_WHS){
            setHead(t('pages.delivery.task.warehouseTitle'));
        }
    }, [title,tableRows,data]);

    return (
        <div className="max-w-md mx-auto bg-white overflow-hidden">
            <div className="fixed top-0 left-0 right-0 z-10 bg-white">
                <div {...getNavBarContainerStyle('pb-1')}>
                    <NavBar
                        onBack={() => navigate(path)}
                        backIcon={<ArrowLeftOutlined/>}
                    >
                        {head}
                    </NavBar>
                </div>
                <div className="p-1">
                    <div className="grid grid-cols-12 mb-1 font-medium text-gray-500 border-b-2">
                        <div className="col-span-7 px-1">{tableRows[0]}</div>
                        <div className="col-span-5 px-1">{tableRows[1]}</div>
                    </div>
                </div>
            </div>

            <div className="mt-20">
                {data.length > 0 && (
                    <div className="p-4">
                        {data.map((item, index) => (
                            <div key={index} className="grid grid-cols-12 py-3 border-b border-gray-100">
                                <div className="col-span-7 px-1 font-mono text-sm break-all">
                                    {item.trackingNumber}
                                </div>
                                <div className="col-span-5 px-1 font-mono text-sm">
                                    {item.value}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TrackingTable;